import BlockEditorInformation from '../BlockEditorInformation';

const PageLegales = ({user,validateproductos,itemshopping,resumen,removeProduct,subTotal,miproductos,expressActive,changeHasExpress,changeMethodShopping,methodShopping,loadMenu,loadTransversal,transversal,menus,myLazyLoad,myListCart,handleMiproductos,handleSubTotal}) =>{
	
	return (
		<div id="ms-profile">

	        <div className="ms-section">
	        	<BlockEditorInformation />
            </div>

	        </div>
	)

}

export default PageLegales

//